export default __webpack_public_path__ + "static/media/README.a05c68a5.md";